import styled, { css } from 'styled-components';
import { NavLink, Link } from 'react-router-dom';

import UserAndActionsImport from '../../components/user-and-actions/UserAndActions';

const linkStyles = css`
  text-decoration: none;
  color: var(--d-grey);
  transition: color 0.2s;
  &:hover {
    color: var(--accent);
  }
`;

export const NavItem = styled(NavLink)`
  ${linkStyles}
  margin-bottom: 1rem;
  padding: 1rem 0;
  font-size: 1.8rem;
  font-weight: bold;
  &.active-link {
    color: var(--accent);
    cursor: default;
  }
`;

export const FavLink = styled(Link)`
  display: flex;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  ${linkStyles}
  color: var(--grey);
  img {
    margin-right: 1rem;
  }
`;

export const SignInLink = styled(Link)`
  ${linkStyles}
  font-size: 1.2rem;
  text-align: center;
  margin-top: 0.8rem;
`;

export const StyledMenu = styled.nav`
  width: 180px;
  display: flex;
  flex-direction: column;
  text-align: left;
  transition: transform 0.2s ease-in-out;
  z-index: 10;
  background: #fff;
  position: fixed;
  top: 12rem;
  img {
    height: 100%;
  }

  @media screen and (max-width: 800px) {
    height: 100vh;
    width: 210px;
    padding-top: 5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    position: fixed;
    top: 0;
    right: 0;
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
    ${({ open }) => open && 'box-shadow: 0 0 0 800px rgba(0, 0, 0, 0.5);'}
  }
`;

export const UserAndActions = styled(UserAndActionsImport)`
  align-self: flex-end;
  @media (min-width: 800px) {
    display: none;
  }
`;

export const Text = styled.p`
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2rem;
`;
